var map = {
	"./": [
		1183
	],
	"./404": [
		9929,
		3204,
		2389
	],
	"./404.jsx": [
		9929,
		3204,
		2389
	],
	"./Airdrop": [
		1923,
		8085,
		410
	],
	"./Airdrop.jsx": [
		1923,
		8085,
		410
	],
	"./BlogGrid01": [
		7968,
		7046,
		1222
	],
	"./BlogGrid01.jsx": [
		7968,
		7046,
		1222
	],
	"./BlogGrid02": [
		1931,
		7046,
		6456,
		8573
	],
	"./BlogGrid02.jsx": [
		1931,
		7046,
		6456,
		8573
	],
	"./BlogList": [
		7281,
		7046,
		6456,
		3351
	],
	"./BlogList.jsx": [
		7281,
		7046,
		6456,
		3351
	],
	"./CoinPricing": [
		4958,
		3198
	],
	"./CoinPricing.jsx": [
		4958,
		3198
	],
	"./Coinlisting": [
		3208,
		7612
	],
	"./Coinlisting.jsx": [
		3208,
		7612
	],
	"./Contact": [
		5237,
		4009
	],
	"./Contact.jsx": [
		5237,
		4009
	],
	"./Deposit": [
		5310,
		7878,
		1599
	],
	"./Deposit.jsx": [
		5310,
		7878,
		1599
	],
	"./Faq": [
		9521,
		6385
	],
	"./Faq.jsx": [
		9521,
		6385
	],
	"./HomeTwo": [
		327,
		7046,
		6456,
		3204,
		1214,
		8085,
		5397,
		6852
	],
	"./HomeTwo.jsx": [
		327,
		7046,
		6456,
		3204,
		1214,
		8085,
		5397,
		6852
	],
	"./HomeTwo.scss": [
		5078,
		1214,
		5397,
		3813
	],
	"./Kycupload": [
		7684,
		8083,
		7033
	],
	"./Kycupload.jsx": [
		7684,
		8083,
		7033
	],
	"./Launchpad": [
		5538,
		7046,
		8085,
		6741
	],
	"./Launchpad.jsx": [
		5538,
		7046,
		8085,
		6741
	],
	"./LineChart.scss": [
		7107,
		8400
	],
	"./ListingForm": [
		2687,
		5839
	],
	"./ListingForm.jsx": [
		2687,
		5839
	],
	"./Login": [
		9023
	],
	"./Login.jsx": [
		9023
	],
	"./Logout": [
		2958,
		7089
	],
	"./Logout.jsx": [
		2958,
		7089
	],
	"./MarketPagination.scss": [
		3847,
		276
	],
	"./Marketpagination": [
		8361,
		7703
	],
	"./Marketpagination.jsx": [
		8361,
		7703
	],
	"./Markets": [
		9004,
		6456,
		7042
	],
	"./Markets.jsx": [
		9004,
		6456,
		7042
	],
	"./Markets.scss": [
		2924,
		3503
	],
	"./PartnerAuthenticity": [
		7628,
		9788
	],
	"./PartnerAuthenticity.jsx": [
		7628,
		9788
	],
	"./PartnerAuthenticity.scss": [
		4398,
		1677
	],
	"./Privacy": [
		8569,
		4933
	],
	"./Privacy.jsx": [
		8569,
		4933
	],
	"./Refferal": [
		2824,
		9526,
		6610
	],
	"./Refferal.jsx": [
		2824,
		9526,
		6610
	],
	"./Register": [
		857,
		6848
	],
	"./Register.jsx": [
		857,
		6848
	],
	"./Reload": [
		2062
	],
	"./Reload.jsx": [
		2062
	],
	"./Staking": [
		1805,
		8085,
		2350
	],
	"./Staking.jsx": [
		1805,
		8085,
		2350
	],
	"./TermsOfUse": [
		6458,
		8612
	],
	"./TermsOfUse.jsx": [
		6458,
		8612
	],
	"./UserProfile": [
		5219,
		3204,
		8083,
		9773
	],
	"./UserProfile.jsx": [
		5219,
		3204,
		8083,
		9773
	],
	"./Wallet": [
		7252,
		5284
	],
	"./Wallet.jsx": [
		7252,
		5284
	],
	"./Withdrawal": [
		8776,
		7878,
		3997,
		4878
	],
	"./Withdrawal.jsx": [
		8776,
		7878,
		3997,
		4878
	],
	"./about": [
		6830,
		9526,
		7594
	],
	"./about.jsx": [
		6830,
		9526,
		7594
	],
	"./deposit.scss": [
		3647,
		9132
	],
	"./fee": [
		3465,
		7305
	],
	"./fee.jsx": [
		3465,
		7305
	],
	"./fee.scss": [
		8449,
		8850
	],
	"./forget": [
		9569,
		9156
	],
	"./forget.jsx": [
		9569,
		9156
	],
	"./index": [
		1183
	],
	"./index.js": [
		1183
	],
	"./kycupload.scss": [
		9905,
		3074
	],
	"./login.scss": [
		6656
	],
	"./marketChart": [
		6905,
		4661
	],
	"./marketChart.jsx": [
		6905,
		4661
	],
	"./menu": [
		9632
	],
	"./menu.js": [
		9632
	],
	"./notfound.scss": [
		4188,
		9439
	],
	"./trade": [
		3616,
		907
	],
	"./trade.jsx": [
		3616,
		907
	],
	"./trade.scss": [
		9163,
		2824
	],
	"./userProfile.scss": [
		9317,
		9494
	],
	"./wallet.scss": [
		1430,
		5861
	],
	"./withdrawal.scss": [
		5208,
		3997,
		667
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 418;
module.exports = webpackAsyncContext;